import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    Overlay: styled.div `
    width: inherit;
    height: inherit;

    background: rgb(56 55 53 / 20%);
  `,
    LayoutPopup: styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;

    width: inherit;
    height: ${(props) => (props.height ? props.height : 'auto')};
    min-height: 418px;
    overflow: hidden;

    background: ${SEMANTIC_COLORS.DEFAULT_POPUP_BACKGROUND};
    border-radius: 40px 0 0 40px;
  `,
    PopupHeader: styled.div `
    position: relative;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: calc(100% - 30px);
    padding: ${(props) => (props.isRenderProgress ? '19px 10px 17px' : '10px')};

    text-align: center;
    border-bottom: 1px solid rgb(93 134 90 / 50%);
  `,
    PopupHeaderTitle: styled.div `
    font-size: 18px;
    font-weight: 500;
    line-height: 26px;
    color: ${SEMANTIC_COLORS.DEFAULT_TITLE};
  `,
    HeaderProgress: styled.div `
    width: calc(100% - 14px);
    height: 5px;
    margin-bottom: 16px;

    background: ${SEMANTIC_COLORS.DEFAULT_PROGRESS_BACKGROUND};
    border-radius: 10.5px;

    & > div {
      width: ${(props) => `calc((${props.value} / ${props.max}) * 100%)`};
      height: 100%;
      background: ${SEMANTIC_COLORS.DEFAULT_PROGRESS_BAR};
      border-radius: 10.5px;

      transition: width 0.3s ease;
    }
  `,
    PopupHeaderCloseButton: styled.button `
    position: absolute;
    top: 8px;
    right: 0;

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;

    font-size: 35px;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    background: none;
    border: none;

    cursor: pointer;
  `,
};
